
const SecondayNavigationEmpty = ({ title }) => {
    return (
        <>
            <div className="navbarstiky sticky-top navbar-bg-dark mb-1 pb-2 pt-2">
                <div className="container">
                    <div className="d-flex flex-column flex-xl-row flex-lg-row flex-md-row flex-sm-row justify-content-between">
                        <h5>{title}</h5>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SecondayNavigationEmpty;
